/**
 * @generated SignedSource<<8d4de9994c0a5e3227ab54b7e2a1de62>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutRestrictionAcknowledgement_transaction$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutNeedsToAcknowledgeRestrictions_transaction">;
  readonly " $fragmentType": "CheckoutRestrictionAcknowledgement_transaction";
};
export type CheckoutRestrictionAcknowledgement_transaction$key = {
  readonly " $data"?: CheckoutRestrictionAcknowledgement_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutRestrictionAcknowledgement_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutRestrictionAcknowledgement_transaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutNeedsToAcknowledgeRestrictions_transaction"
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "78fbf325fcb95061c31ae766f81780fd";

export default node;
